(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var types = require('./types');

var n = types.namedTypes;
var b = types.builders;

var Validator = require('./validator');

var validator = new Validator();

module.exports = validator.valid(n.File).transform(n.BinaryExpression, function (path) {
  return b.pbxBinaryExpression(path.node.operator, path.node.left, path.node.right);
}).transform(n.ExpressionStatement, function (path) {
  return b.pbxExpressionStatement(path.node.expression);
}).transform(n.CallExpression, function (path) {
  return b.pbxFunctionExpression.apply(undefined, [path.node.callee].concat(path.node.arguments));
}, function (path) {
  return b.pbxUnaryFunctionExpression(path.node.callee, path.node.arguments[0]);
}).transform(n.Identifier, function (path) {
  if (n.CallExpression.check(path.parentPath.node) && path.parentPath.node.callee === path.node) {
    return path.node.name;
  } else if (n.MemberExpression.check(path.parentPath.node) && path.parentPath.node.property === path.node) {
    return b.pbxLiteral(path.node.name);
  }
  return b.pbxIdentifier(path.node.name);
}).transform(n.Literal, function (path) {
  return b.pbxLiteral(path.node.value);
}).transform(n.LogicalExpression, function (path) {
  return path.node.operator === '&&' ? b.pbxLogicalAndExpression(path.node.left, path.node.right) : b.pbxLogicalOrExpression(path.node.left, path.node.right);
}).transform(n.MemberExpression, function (path) {
  return b.pbxMemberExpression(path.node.object, path.node.property);
}).transform(n.Program, function (path) {
  return b.pbxProgram.apply(undefined, path.node.body);
}).transform(n.UnaryExpression, function (path) {
  return b.pbxUnarySignExpression(path.node.operator, path.node.argument);
}, function (path) {
  return b.pbxUnaryNotExpression(path.node.argument, path.node.operator);
}).build();

})));
//# sourceMappingURL=validate.js.map
